__turbopack_context__.v({
  "reviewBtn": "FJ7klW_reviewBtn",
  "trustPilot": "FJ7klW_trustPilot",
});
